import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";

import { COLOR_FOCUSED } from "~/theme/colors";

import { SORTING_DROPDOWN_CLASSES } from "./constants";

export const SortingDropdownContainer = styled(FormControl, {
  shouldForwardProp: () => true,
})(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& .MuiInputBase-root": {
      marginTop: 0,
      "&::before, &::after": {
        display: "none",
      },
      "& svg": {
        pointerEvents: "none",
        position: "absolute",
        right: "-8px",
        top: 20,
      },
      "& div.MuiSelect-select": {
        paddingRight: theme.spacing(4),
      },
      "& .MuiSelect-select:focus": {
        backgroundColor: "transparent",
        outline: `2px solid ${COLOR_FOCUSED}`,
      },
    },
    "&::before": {
      content: "''",
      position: "absolute",
      left: theme.spacing(-4),
      height: "24px",
      borderLeft: "1px solid rgba(0, 0, 0, 0.08);",
    },
    [`& .${SORTING_DROPDOWN_CLASSES.label}`]: {
      fontSize: 16,
      position: "static",
      transform: "none",
      cursor: "pointer",
    },
  };
});
